import { ILiveManager } from '@src/slide/application/service/live-manager/core/interface';
import { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export const liveManagerDynamicConfig: IDynamicServiceConfig<ILiveManager> = {
    name: 'live-manager',
    loadType: 'on-demand',
    module: async () => {
        const LiveManager = (await import(/* webpackChunkName: "service" */ '@src/slide/application/service/live-manager/core')).default;
        const { LiveManagerInjectable } = (await import(/* webpackChunkName: "service" */ '@src/slide/application/service/live-manager/inject/live-manager-injectable'));

        return new LiveManager(new LiveManagerInjectable());
    },
};
